import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { Box, Metadata, useTranslations } from "@bsm/component";
import { formatLanguage } from "utils/formatLanguage";

export const StudentSchoolAttendedContainer = () => {
  const { id } = useParams();
  const { data } = useStudentDetailsQuery(parseInt(id), true);

  const [
    SCHOOL_ATTENDED,
    SCHOOL_NAME,
    ATTENDED_PERIOD,
    LOCATION,
    REFEREE_1,
    REFEREE_2,
    REFEREE_NAME,
    POSITION,
    LANGUAGE,
    PHONE,
    EMAIL,
  ] = useTranslations(i18nKeys);

  return (
    <div className="overflow-hidden rounded-3xl shadow bg-white">
      <Box className="p-[3rem]">
        <h3 className="text-2xl font-bold mt-5 p-5">{SCHOOL_ATTENDED}</h3>
        {data?.schoolAttended?.map((sa) => (
          <div className="gap-3 py-4 border-b border-[#00000029] last:border-b-0 w-max">
            <Metadata label={SCHOOL_NAME} value={sa?.schoolName} />
            <Metadata label={ATTENDED_PERIOD} value={sa?.attendedPeriod} />
            <Metadata label={LOCATION} value={sa?.location} />
            <Metadata label={LANGUAGE} value={formatLanguage(sa?.languageOfInstitution)} />
            <p className="font-bold mt-3">{REFEREE_1}</p>
            <Metadata label={REFEREE_NAME} value={sa?.referee1Name} />
            <Metadata label={POSITION} value={sa?.referee1Position} />
            <Metadata label={PHONE} value={sa?.referee1Phone} />
            <Metadata label={EMAIL} value={sa?.referee1Email} />
            {(sa?.referee2Name || sa?.referee2Position || sa?.referee2Phone || sa?.referee2Email) && (
              <>
                <p className="font-bold mt-3">{REFEREE_2}</p>
                <Metadata label={REFEREE_NAME} value={sa?.referee2Name} />
                <Metadata label={POSITION} value={sa?.referee2Position} />
                <Metadata label={PHONE} value={sa?.referee2Phone} />
                <Metadata label={EMAIL} value={sa?.referee2Email} />
              </>
            )}
          </div>
        ))}
      </Box>
    </div>
  );
};

const i18nKeys = [
  "std_school_attended",
  "std_school_name",
  "std_attended_period",
  "std_location_of_school",
  "std_referee_1",
  "std_referee_2",
  "std_referee_name",
  "std_position",
  "std_language_of_institution",
  "std_phone",
  "std_email",
];
